import {
    UserIcon,
    PhoneIcon,
    MapPinIcon,
    AcademicCapIcon,
    BriefcaseIcon,
    BuildingOfficeIcon,
    InformationCircleIcon,
    EnvelopeIcon,
} from "@heroicons/react/24/outline";

/**
 * Helper Function: Remove duplicate fields
 */
export const getUniqueFields = (fields) => {
    const seen = new Map();
    return fields.filter((field) => {
        // Use FieldName as the primary key to avoid duplicates
        // This ensures that even if values differ, we don't show the same field type twice
        const key = field.FieldName || field.MasterFieldId;
        if (seen.has(key)) return false;
        seen.set(key, true);
        return true;
    });
};

/**
 * Helper Function: Get icon & color for each category
 */
export const getCategoryConfig = (categoryName) => {
    const configMap = {
        "Personal Info": {
            icon: UserIcon,
            bgClass: "bg-indigo-100 dark:bg-indigo-900/20",
            iconClass: "text-indigo-600",
        },
        "Contact Info": {
            icon: PhoneIcon,
            bgClass: "bg-green-100 dark:bg-green-900/20",
            iconClass: "text-green-600",
        },
        "Demographic Info": {
            icon: MapPinIcon,
            bgClass: "bg-blue-100 dark:bg-blue-900/20",
            iconClass: "text-blue-600",
        },
        "Employment Info": {
            icon: AcademicCapIcon,
            bgClass: "bg-purple-100 dark:bg-purple-900/20",
            iconClass: "text-purple-600",
        },
        "Education Info": {
            icon: BriefcaseIcon,
            bgClass: "bg-orange-100 dark:bg-orange-900/20",
            iconClass: "text-orange-600",
        },
        "Account Info": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Medical Info": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Event Info": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Property Info": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Attachments": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Inquiry Info": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Financial Info": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
        "Other": {
            icon: BuildingOfficeIcon,
            bgClass: "bg-teal-100 dark:bg-teal-900/20",
            iconClass: "text-teal-600",
        },
    };

    return (
        configMap[categoryName] || {
            icon: InformationCircleIcon,
            bgClass: "bg-amber-100 dark:bg-amber-900/20",
            iconClass: "text-amber-600",
        }
    );
};

/**
 * Helper Function: Get appropriate icon for field type
 */
export const getFieldIcon = (fieldName) => {
    if (!fieldName) return InformationCircleIcon;
    const lowerFieldName = fieldName.toLowerCase();

    if (lowerFieldName.includes("email")) return EnvelopeIcon;
    if (lowerFieldName.includes("phone") || lowerFieldName.includes("mobile"))
        return PhoneIcon;
    if (
        lowerFieldName.includes("city") ||
        lowerFieldName.includes("state") ||
        lowerFieldName.includes("country") ||
        lowerFieldName.includes("address")
    )
        return MapPinIcon;
    if (lowerFieldName.includes("name")) return UserIcon;

    return InformationCircleIcon;
};
